import React from "react";
import { motion } from "framer-motion";
import { optimizeImageUrl, HERO_PAGE_WIDTH } from "../lib/images";

export default function PageHero({ title, highlight, subtitle, image }) {
  const heroSrc = image ? optimizeImageUrl(image, HERO_PAGE_WIDTH) : null;

  return (
    <section className="relative pt-[74px] overflow-hidden">
      <div className="relative h-[300px] md:h-[340px]">
        {heroSrc && (
          <>
            <img
              src={heroSrc}
              alt=""
              loading="lazy"
              decoding="async"
              className="absolute inset-0 w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#06060d] via-[#06060d]/80 to-[#06060d]/50" />
            <div className="absolute inset-0 bg-gradient-to-r from-[#06060d]/90 to-transparent" />
          </>
        )}
        <div className="relative tv-container h-full flex flex-col justify-center">
          <motion.h1
            initial={{ opacity: 0, y: 26 }} animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, ease: "easeOut" }}
            className="font-display font-extrabold text-4xl md:text-5xl text-white"
          >
            {title} {highlight && <span className="tv-glow-text">{highlight}</span>}
          </motion.h1>
          {subtitle && (
            <motion.p
              initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.15 }}
              className="text-[var(--tv-muted)] mt-4 max-w-2xl leading-relaxed"
            >
              {subtitle}
            </motion.p>
          )}
        </div>
      </div>
    </section>
  );
}
